var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCopyIcon = function SvgCopyIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4D5B5A",
    fillRule: "evenodd",
    d: "M3.625 2.5a.375.375 0 0 0-.375.375v10.5a.375.375 0 0 0 .375.375h.79a.75.75 0 1 1 0 1.5h-.79a1.875 1.875 0 0 1-1.875-1.875v-10.5A1.875 1.875 0 0 1 3.625 1h6.097c.497 0 .973.198 1.325.549l1.077 1.077a.75.75 0 0 1-1.06 1.06L9.986 2.61a.38.38 0 0 0-.264-.11z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4D5B5A",
    d: "M14.173 4.75H8.125A1.875 1.875 0 0 0 6.25 6.625v10.5A1.875 1.875 0 0 0 8.125 19h8.25a1.875 1.875 0 0 0 1.875-1.875V8.827a1.88 1.88 0 0 0-.549-1.326l-2.202-2.202a1.88 1.88 0 0 0-1.326-.549"
  })));
};
export { SvgCopyIcon as ReactComponent };